<template>
  <div>
    <el-card>
      <el-table :data="userlist" border style="width: 100%" show-overflow-tooltip="true" tooltip-effect="dark"
        ref="multipleTable" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="40">
        </el-table-column>
        <el-table-column prop="username" label="用户名" width="180">
        </el-table-column>
        <el-table-column prop="name" label="姓名" width="180">
        </el-table-column>
        <el-table-column prop="email" label="邮箱" width="180">
        </el-table-column>
        <el-table-column prop="mobiles" label="手机号" width="180">
        </el-table-column>
        <el-table-column prop="studentID" label="学号" width="180">
        </el-table-column>
        <el-table-column prop="date" label="创建时间" width="180">
        </el-table-column>
        <el-table-column prop="addType" label="是否为班干部" width="180" :formatter="stateFormat">
        </el-table-column>
        <el-table-column
      label="设置班干部"
      width="110">
      <template slot-scope="scope">
<el-button  @click="setUser(scope.row)">更改权限</el-button>
      </template>
    </el-table-column>
        <!-- <el-table-column
      label="操作"
      width="150">
      <template slot-scope="scope">
<el-button disabled  @click="updateNew(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-xiugai"></use></svg></el-button>
<el-button  @click="deleteUser(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></el-button>
      </template>
    </el-table-column> -->
      </el-table>
      <el-button @click="selectDatas">导出Excel</el-button>
      <el-button @click="toggleSelection()">取消选择</el-button>
    </el-card>
  </div>
</template>

<script>
export default {
  created() {
    this.getUsers()
  },
  data() {
    return {
      userlist: [],
      multipleSelection: [],
    }
  },
  methods: {
    getUsers() {
      this.axios.post("/user/getUserByInstrutorID?tutorid=" + JSON.parse(localStorage.getItem('user')).userid)
        .then(res => {
          if (res.data.status == 1) {
            console.log(res.data.result)
            this.userlist = res.data.result;
          } else {
            alert("拿取数据失败")
          }
        })
        .catch((err) => {
          // alert("出错了")
          console.log(err)
        })
    },     stateFormat(row, column) {
    if (row.addType =='8') {
      return '是'
    } else  {
      return '否'
    } 
  },setUser(data){
    if(data.addType==8){
      const that=this
        this.$confirm("确定去除"+data.name+"班干部权限？","提示",{
          confirmButtonText: "确认",//确认按钮文字更换
          cancelButtonText: "取消",//取消按钮文字更换
          showClose: true,//是否显示右上角关闭按钮
          type: "warning",//提示类型  success/info/warning/error
      }).then(function(){  
        that.axios.post("/user/addType?type=1&userid="+data.userid)
          .then(resp => { 
                      if(resp.data.status == 1) {    
                        that.$message.success("成功") 
                        that.getUsers()                                                                                                                                                                   
                                }else {
                                   alert("设置失败")                                 
                                }
                            })
                            .catch((err) => {
                               alert("出错了")
                                console.log(err)
                            }) 
      }).catch(()=>{});
    }else{
      const that=this
        this.$confirm("确定设定"+data.name+"为班干部权限？","提示",{
          confirmButtonText: "确认",//确认按钮文字更换
          cancelButtonText: "取消",//取消按钮文字更换
          showClose: true,//是否显示右上角关闭按钮
          type: "warning",//提示类型  success/info/warning/error
      }).then(function(){  
        that.axios.post("/user/addType?type=8&userid="+data.userid)
          .then(resp => { 
                      if(resp.data.status == 1) {    
                        that.$message.success("成功") 
                        that.getUsers()                                                                                                                                                                   
                                }else {
                                   alert("设置失败")                                 
                                }
                            })
                            .catch((err) => {
                               alert("出错了")
                                console.log(err)
                            }) 
      }).catch(()=>{});
    }
   console.log(data)
  },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }, toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    }, selectDatas() {

      if (this.multipleSelection.length === 0) {
        this.$message.error("请选择导出列表")
        return
      }
      this.axios({
        url: "/user/exportExcel",   //后端地址
        method: "post",
        data: this.multipleSelection, //请求参数
        headers: {
          'Access-Control-Allow-origin': '*', 'Content-Type': 'application/json; charset=UTF-8',
        },
        // contenType:'application/json',
        responseType: "blob"
      })
        .then(res => {
          const blob = new Blob([res.data], { type: 'xlsx' });
          const fileName = "数据报表.xlsx";
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
          this.selectData = false
        })
    },
  }
}
</script>

<style>
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/work/instructor/ViewStudentInfo.vue